import { TrackingUserInfo } from '../../models/tracking-user-info/tracking-user-info.model';

export abstract class AbstractTrackingService {
    abstract init(userInfo?: TrackingUserInfo): void;
    abstract trackEvent(event: string, properties: unknown): void;
}
